import { ValueSeparator } from './separators';
export var SelectFilterOperationType = /*#__PURE__*/ function(SelectFilterOperationType) {
    SelectFilterOperationType["Is"] = "Is";
    SelectFilterOperationType["IsNot"] = "IsNot";
    SelectFilterOperationType["IsOneOf"] = "IsOneOf";
    SelectFilterOperationType["IsNoneOf"] = "IsNoneOf";
    SelectFilterOperationType["IsEmpty"] = "IsEmpty";
    SelectFilterOperationType["IsNotEmpty"] = "IsNotEmpty";
    // IsAtLeast & IsAtMost are used for single choice fields ONLY
    SelectFilterOperationType["IsAtLeast"] = "IsAtLeast";
    SelectFilterOperationType["IsAtMost"] = "IsAtMost";
    return SelectFilterOperationType;
}({});
export const SelectFilterOperationTypes = [
    "Is",
    "IsNot",
    "IsOneOf",
    "IsNoneOf",
    "IsEmpty",
    "IsNotEmpty"
];
export const SelectFilterOperationTypesWithoutEmpty = [
    "Is",
    "IsNot",
    "IsOneOf",
    "IsNoneOf"
];
export const SelectFilterOperationTypesForLevelField = [
    "Is",
    "IsNot",
    "IsAtLeast",
    "IsAtMost",
    "IsEmpty",
    "IsNotEmpty"
];
export const SelectFilterOperationTypesForSprintField = [
    "IsEmpty",
    "IsNotEmpty"
];
export const isOptional = (type)=>type === "IsEmpty" || type === "IsNotEmpty";
export const isOptionalForTaskBlockingStatus = (type)=>type === "Is" || type === "IsNot" || type === "IsEmpty" || type === "IsNotEmpty";
export const valueToString = (mapper)=>(value)=>{
        return value.map((x)=>mapper(x)).join(ValueSeparator);
    };
export const valueFromString = (mapper, valueSeparator = ValueSeparator)=>(value)=>{
        return (value !== null && value !== void 0 ? value : '').split(valueSeparator).filter((x)=>x !== '').map((x)=>mapper(x));
    };
